import { usePopup } from '@/composables/hconUsePopup'
import SessionStorageSynchronizer from '~/utils/sync-sessionstorage';
// 전역 팝업
const {
    isTimeOut,
    isLoggedIn,
    openLoginPopupReqAuth,
    openLoginPopup,
    showConfirm,
    showAlert,
} = usePopup()

const { recentSearchwordsInfo } = useHeader()

export default defineNuxtRouteMiddleware(async (to, from) => {
    
    const now = new Date();
    const fromDtm = '2026-05-04T12:40:00';
    const toDtm   = '2026-05-04T12:50:00';

    const isMaintenance = now >= new Date(fromDtm) && now <= new Date(toDtm);

    if(isMaintenance) {
        try {
            if(useHconAuthInfo().getIfPossible()?.accessToken && useHconAuthInfo().getIfPossible()?.refreshToken) {
                const res = await $fetch.raw<AjaxResult<any>>('/api/v1/member/auth/logout', {
                    baseURL: useHconConfig().api.baseUrl,
                    method: 'POST',
                    //credentials: 'include',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: {
                    accessToken : useHconAuthInfo().getIfPossible()?.accessToken,
                    refreshToken : useHconAuthInfo().getIfPossible()?.refreshToken
                    }
                });

                if (res.status == 200) {
                    if (res._data?.resultCode == '200') {

                        isLoggedIn.value = false;
                        localStorage.setItem('common.auth.isRememberMe','N');
                        useHconAuthInfo().clear();
                        const { $stopTimer } = useNuxtApp();
                        $stopTimer();
                        recentSearchwordsInfo.value = [];

                        await nextTick();
                        localStorage.setItem('auth:event', JSON.stringify({
                            type: 'LOGOUT',
                            at: Date.now()
                        }));
                    }
                }
            }

        } catch (error) {
            console.error('session fail', error);
        } 
    }

    // 점검 시간대이면 점검 페이지로 이동
    if (isMaintenance && to.path !== '/pc/common/info/under-maintenance') {
        return navigateTo({
            path: '/pc/common/info/under-maintenance',
            query: {
            from: fromDtm,
            to: toDtm
            }
        })
    }

    // 점검 끝이면 점검 페이지 접근 막기
    if (!isMaintenance && to.path === '/pc/common/info/under-maintenance') {
        return navigateTo('/');
    }

    // 발신번호 관리 페이지 접근 막기
    if(to.path === '/pc/mypage/sender') {
        return navigateTo('/'); 
    }
    
    //  나머지는 정상 통과
    if (import.meta.client) {

        //TODO : 경로별 로그인 팝업 띄우기
        const protectedPaths = [
            '/mypage',
            '/order/application-form',
            '/order/basket',
            '/order/complete',
            '/order/estimate/list',
            '/order/payment',
            '/order/temp-save',
            '/pin-publication-request',
            '/inquiry/register',
            '/common/password'
        ]

        const isProtectedPaths = protectedPaths.some(path => to.path.startsWith('/pc'+path));
        const requireAuth   = to.matched.
        length > 0
        && !to.path.startsWith('/_nuxt/')
        && !to.path.startsWith('/static/')
        && !to.path.startsWith('/pub/')
        && isProtectedPaths

        let authInfoJson        = sessionStorage.getItem('common.auth.info');
        let isAuthExpired       = false;
        
        if (authInfoJson) {
            const authInfo: AuthInfo    = JSON.parse(authInfoJson);
            const now                   = new Date().getTime();
            const accessExpireTime      = authInfo.lastAccess + authInfo.accessTimeout;
            if (now < accessExpireTime) {
                authInfo.lastAccess = now;
                sessionStorage.setItem('common.auth.info', JSON.stringify(authInfo));
                return;
            } else {
                sessionStorage.removeItem('common.auth.info');
                authInfoJson    = null;
                isAuthExpired   = true;
            }
        }

        if (authInfoJson == null) {

            const rememberMeToken = localStorage.getItem('common.auth.isRememberMe') == 'N' ? null : SessionStorageSynchronizer.getItem('common.auth.rememberMe');

            if (rememberMeToken != null) {
                try {
                    const res = await $fetch.raw<AjaxResult<any>>('/api/v1/member/auth/auto-login', {
                        baseURL: useHconConfig().api.baseUrl,
                        method: 'POST',
                        //credentials: 'include',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'X-Remember-Me': rememberMeToken,
                        },
                    });
                    isLoggedIn.value = true;
                    useHconAuthInfo().setFromFetch(res);
                    window.location.reload();
                    return;
                } catch (error) {
                    console.error('auto-login fail', error);
                }
            }
        }
        if(!authInfoJson && isProtectedPaths) {
            if(!from.name) {
                if (to.path === '/pc/mypage/information') {
                    showAlert({
                        title: '로그인 필수 화면 안내', 
                        message : "로그인이 필요한 화면입니다. 로그인 후 재시도 해주세요.",
                        cancelButtonYn: 'N',
                        onConfirm: () => {
                          openLoginPopup(true)
                        }
                      })
                      return false;
                }
                    showAlert({
                        title: '로그인 필수 화면 안내', 
                        message : "로그인이 필요한 화면입니다. 로그인 후 재시도 해주세요.",
                        cancelButtonYn: 'N',
                        onConfirm: () => {
                          openLoginPopup(true)
                        }
                      })

				 return useRouter().go(-1); 
            }

            const result = await showConfirm({
                title: '로그인 필수 화면 안내',
                message: "로그인이 필요한 화면입니다. 로그인 하시겠습니까?",
                confirmText: '확인',
                cancelText: '취소'
              })

            if(result) {
                openLoginPopup();
                return false;
            } else {
                return false;
            }
        }
        if (isAuthExpired) {
            isTimeOut.value = true;
            return ;
        } 
        
        if (requireAuth) {
            openLoginPopupReqAuth();
            return ;
        }
        
    }
})